import dashboard from './dashboard.js';
import { Router } from '@/legacy/Router';

Router.get('judge', dashboard);
